var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthBannerItemA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 77,
    viewBox: "0 0 86 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.24524,
    height: 34.4336,
    rx: 2.12262,
    transform: "matrix(-1 0 0 1 18.4561 40.5664)",
    fill: "#4C4C4C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.24524,
    height: 25.4715,
    rx: 2.12262,
    transform: "matrix(-1 0 0 1 30.248 49.5293)",
    fill: "#4C4C4C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.24524,
    height: 15.5659,
    rx: 2.12262,
    transform: "matrix(-1 0 0 1 42.04 59.4346)",
    fill: "#4C4C4C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.24524,
    height: 7.5471,
    rx: 2.12262,
    transform: "matrix(-1 0 0 1 53.834 67.4531)",
    fill: "#4C4C4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5566 54.6386C66.9158 52.2223 69.6713 49.0627 71.6084 45.4062C73.5454 41.7496 74.6116 37.6951 74.7237 33.5587C74.8359 29.4223 73.9909 25.3159 72.2548 21.5598C70.5187 17.8037 67.9383 14.4994 64.715 11.9047C61.4917 9.30995 57.7125 7.49493 53.6723 6.60116C49.632 5.7074 45.44 5.75905 41.423 6.7521C37.406 7.74515 33.6727 9.65274 30.5143 12.3261C27.3559 14.9995 24.8577 18.3663 23.2147 22.164",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9359 43.4644V16.7266H49.9028V43.4644H47.9359ZM48.5488 40.9132C47.3326 40.9132 46.2541 40.7897 45.3134 40.5427C44.3823 40.2956 43.5794 39.9298 42.9048 39.4452C42.2396 38.9606 41.7028 38.3668 41.2942 37.6636C40.8856 36.9605 40.5958 36.1529 40.4248 35.2407L43.2041 34.0292C43.5461 35.0839 43.9452 35.9201 44.4013 36.5377C44.8669 37.1553 45.4512 37.5971 46.1544 37.8632C46.867 38.1292 47.7601 38.2622 48.8338 38.2622C49.7935 38.2622 50.5774 38.1387 51.1855 37.8917C51.7936 37.6351 52.2402 37.2693 52.5253 36.7942C52.8198 36.3096 52.9623 35.73 52.9528 35.0554C52.9433 34.1812 52.7961 33.5066 52.511 33.0315C52.226 32.5565 51.7176 32.1526 50.986 31.8201C50.2639 31.4875 49.2282 31.1027 47.8789 30.6656C46.5392 30.2285 45.3657 29.7914 44.3585 29.3544C43.3513 28.9173 42.5674 28.3329 42.0068 27.6013C41.4462 26.8602 41.1659 25.834 41.1659 24.5227C41.1659 23.3825 41.432 22.4276 41.9641 21.658C42.5057 20.8788 43.3228 20.2945 44.4155 19.9049C45.5177 19.5058 46.9097 19.3063 48.5915 19.3063C49.7698 19.3063 50.7722 19.4203 51.5988 19.6483C52.435 19.8764 53.1761 20.2517 53.8222 20.7743C54.4684 21.2874 55.0907 21.9905 55.6893 22.8837L53.4232 24.6368C52.8151 23.6486 52.1737 22.9502 51.4991 22.5416C50.8245 22.133 49.9788 21.9288 48.9621 21.9288C47.9739 21.9288 47.1568 22.0238 46.5107 22.2138C45.8645 22.3943 45.38 22.6651 45.0569 23.0262C44.7433 23.3778 44.5866 23.8101 44.5866 24.3232C44.5866 24.9218 44.6863 25.4016 44.8859 25.7627C45.0949 26.1143 45.4227 26.4041 45.8693 26.6321C46.3159 26.8602 46.8907 27.0835 47.5939 27.302C48.3065 27.5205 49.1664 27.7961 50.1736 28.1286C51.4468 28.5467 52.5443 29.0218 53.4659 29.5539C54.3971 30.086 55.1145 30.7796 55.6181 31.6348C56.1217 32.4804 56.3735 33.5874 56.3735 34.9556C56.3735 36.2669 56.0837 37.3643 55.5041 38.248C54.9245 39.1317 54.055 39.7968 52.8958 40.2434C51.7366 40.6899 50.2876 40.9132 48.5488 40.9132Z",
    fill: "#4C4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13572 17.6892C7.13572 17.6892 19.3984 35.6141 40.3896 50.4723C66.0795 68.6563 78.8321 71.2264 78.8321 71.2264",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8311 71.2266L65.1519 75.0001",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8311 71.2266L73.1707 59.4342",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBannerItemA);
export default __webpack_public_path__ + "static/media/AuthBannerItemA.e877acca58f342924873893b78af1d24.svg";
export { ForwardRef as ReactComponent };